import DateRangePicker from 'Global/Components/CommonComponents/DateRangePicker/DateRangePicker';
import EditableCustomizableSelect from 'Global/Components/EditableComponents/EditableCustomizableSelect/EditableCustomizableSelect';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import React, { useState } from 'react';
import { Stack } from '@mui/material';
const RequieredSearchField = (props) => {
  const {
    setFilter,
    labType,
    noeTaeed,
    label_combo_label,
    label_confirm_type,
  } = props;

  const paziresh_based = FindLangKey(
    'lab-patient-tarikh-type-paziresh'
  );
  const javabdehi_based = FindLangKey(
    'lab-patient-tarikh-type-javab-dehi'
  );

  const tariksh_type_label = FindLangKey(
    'lab-patient-tarikh-type-label'
  );

  const record_count = FindLangKey(
    'lab-patient-record-count'
  );

  const tariksh_type = [
    {
      ItemContent: paziresh_based,
      ItemValue: 0,
    },
    {
      ItemContent: javabdehi_based,
      ItemValue: 1,
    },
  ];

  const top_Record = [
    {
      ItemContent: '20',
      ItemValue: 20,
    },
    {
      ItemContent: '50',
      ItemValue: 50,
    },
    {
      ItemContent: '100',
      ItemValue: 100,
    },
  ];

  return (
    <React.Fragment>
      <EditableCustomizableSelect
        initialData={[
          {
            ItemValue: labType[0]?.ItemContent,
            ItemContent: labType[0]?.ItemContent,
          },
        ]}
        isSingle={true}
        SelectableDataArray={labType}
        label={label_combo_label}
        onChange={(val) => {
          setFilter((prev) => ({
            ...prev,
            idPato: val,
          }));
        }}
        enableInitialOnchange
      />

      <EditableCustomizableSelect
        initialData={[
          {
            ItemValue: tariksh_type[0]?.ItemContent,
            ItemContent: tariksh_type[0]?.ItemContent,
          },
        ]}
        isSingle={true}
        SelectableDataArray={tariksh_type}
        label={tariksh_type_label}
        onChange={(val) => {
          setFilter((prev) => ({
            ...prev,
            noeTarikh: val,
          }));
        }}
        enableInitialOnchange
      />

      {/* <SingularDatePicker label={label_date_insert} /> */}
      <div
        style={{
          marginBlock: '-.5em',
        }}
      >
        <DateRangePicker
          ExcludeOneMonth={true}
          disableMt
          onChange={(val) => {
            setFilter((prev) => ({
              ...prev,
              fromDate: val.FromDate,
              toDate: val.ToDate,
            }));
          }}
        />
      </div>
      <Stack
        style={{
          marginTop: '-.5em',
        }}
        direction="row-reverse"
        gap="1em"
      >
        <EditableCustomizableSelect
          initialData={[
            {
              ItemValue: noeTaeed[0]?.ItemContent,
              ItemContent: noeTaeed[0]?.ItemContent,
            },
          ]}
          isSingle={true}
          SelectableDataArray={noeTaeed}
          label={label_confirm_type}
          onChange={(val) => {
            setFilter((prev) => ({
              ...prev,
              noeTaeed: val,
            }));
          }}
          enableInitialOnchange={true}
        />
        <EditableCustomizableSelect
          initialData={[
            {
              ItemValue: top_Record[0]?.ItemContent,
              ItemContent: top_Record[0]?.ItemContent,
            },
          ]}
          isSingle={true}
          SelectableDataArray={top_Record}
          label={record_count}
          onChange={(val) => {
            setFilter((prev) => ({
              ...prev,
              topRecord: val,
            }));
          }}
          enableInitialOnchange={true}
        />
      </Stack>
    </React.Fragment>
  );
};

export default RequieredSearchField;
